"use strict";
import { ReactComponent as UnknownStatus } from "assets/svg/contract-interaction.svg";
import Identicon from "components/Identicon";
import CurrencyLogo from "components/Logo/CurrencyLogo";
import { DoubleCurrencyLogo } from "components/Logo/DoubleLogo";
import styled from "styled-components";
import { memo } from "react";
import { Flex } from "ui/src";
import { CombinedLogo } from "components/CurrencyLogo/SplitLogo";
import { TokenLogo } from "components/CurrencyLogo/TokenLogo";
import { getTokenLogoUrl } from "constants/tokenLogos";
import { SUPPORTED_TESTNET_CHAIN_IDS } from "features/chains/types";
const UnknownContract = styled(UnknownStatus)`
  color: ${({ theme }) => theme.neutral2};
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
`;
const LOGO_DEFAULT_SIZE = 40;
export const PortfolioLogo = memo(function PortfolioLogo2(props) {
  if (SUPPORTED_TESTNET_CHAIN_IDS.includes(props.chainId)) {
    if (props.images && props.images.length >= 2 && (props.images[0] || props.images[1])) {
      return <CombinedLogo
        inputLogoUrl={props.images[0]}
        outputLogoUrl={props.images[1]}
        inputCurrencyInfo={null}
        outputCurrencyInfo={null}
        chainId={props.chainId}
        size={props.size || LOGO_DEFAULT_SIZE}
      />;
    }
    if (props.currencies && props.currencies.length >= 2) {
      const size = props.size || LOGO_DEFAULT_SIZE;
      const overlap = Math.round(size / 3);
      const [c0, c1] = props.currencies;
      const resolveLogoUrl = (c) => {
        if (!c) return void 0;
        if (c.isNative) return "/images/tokens/bnb-logo.png";
        return c.isToken ? getTokenLogoUrl(c.address) ?? void 0 : void 0;
      };
      const c0LogoUrl = resolveLogoUrl(c0);
      const c1LogoUrl = resolveLogoUrl(c1);
      return <Flex row>
          <TokenLogo
        size={size}
        chainId={props.chainId}
        symbol={c0?.symbol}
        name={c0?.name}
        url={c0LogoUrl}
      />
          <Flex ml={-overlap}>
            <TokenLogo
        size={size}
        chainId={props.chainId}
        symbol={c1?.symbol}
        name={c1?.name}
        url={c1LogoUrl}
      />
          </Flex>
        </Flex>;
    }
    if (props.images?.[0]) {
      return <TokenLogo
        url={props.images[0]}
        size={props.size}
        chainId={props.chainId}
        symbol={props.tokenSymbol}
        name={props.tokenName}
      />;
    }
    if (props.currencies?.[0]) {
      const currency = props.currencies[0];
      const logoUrl = currency.isNative ? "/images/tokens/bnb-logo.png" : currency.isToken ? getTokenLogoUrl(currency.address) ?? void 0 : void 0;
      if (logoUrl) {
        return <TokenLogo
          url={logoUrl}
          size={props.size}
          chainId={props.chainId}
          symbol={currency.symbol}
          name={currency.name}
        />;
      }
      return <CurrencyLogo currency={currency} size={props.size} />;
    }
    if (props.tokenSymbol) {
      return <TokenLogo size={props.size} chainId={props.chainId} symbol={props.tokenSymbol} name={props.tokenName} />;
    }
    return <UnknownContract width={props.size || LOGO_DEFAULT_SIZE} height={props.size || LOGO_DEFAULT_SIZE} />;
  }
  return <LogoContainer style={props.style}>
      <Flex position="relative">{getLogo(props)}</Flex>
    </LogoContainer>;
});
function getLogo({
  accountAddress,
  currencies,
  images,
  chainId,
  customIcon,
  tokenSymbol,
  tokenName,
  size = LOGO_DEFAULT_SIZE
}) {
  if (accountAddress) {
    return <Identicon account={accountAddress} size={size} />;
  }
  if (currencies && currencies.length) {
    return <DoubleCurrencyLogo currencies={currencies} size={size} customIcon={customIcon} />;
  }
  if (images && images.length >= 2) {
    return <CombinedLogo
      inputLogoUrl={images[0]}
      outputLogoUrl={images[1]}
      inputCurrencyInfo={null}
      outputCurrencyInfo={null}
      chainId={chainId}
      size={size}
    />;
  }
  if (images && images.length === 1) {
    return <TokenLogo url={images[0]} size={size} chainId={chainId} symbol={tokenSymbol} name={tokenName} />;
  }
  return <UnknownContract width={size} height={size} />;
}
